import { render, staticRenderFns } from "./TrafiklabWidget.vue?vue&type=template&id=df2b1d52&scoped=true&"
import script from "./TrafiklabWidget.vue?vue&type=script&lang=js&"
export * from "./TrafiklabWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrafiklabWidget.vue?vue&type=style&index=0&id=df2b1d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2b1d52",
  null
  
)

export default component.exports